import baseLink from '../baseLink';
import {gtmCheckoutEvent, getContractFunnelGAEvent, getContractGAEvent, gtmAchatEvent} from '@legalplace/lp-events'
import {HARCODED_CHECKOUT_META_IDS} from '../constants/hardcoded_checkout'
import lpApp from '../app/lp_app'

window.dataLayer= window.dataLayer || []
window.exectuteOnceCheckoutActe = 1

/**
 * @description compilation time event
 */

function EventTracking() {
  this.queue = [];
  this.queueTimer = null;
  this.data_uri = baseLink + '/data';
  this.packName = undefined // Save packName here as we need it after payment confirmation

  this.register({
    'React Build': typeof (window.build_date) === 'string' ? window.build_date : 'Unkown',
    'Powered By': 'ReactJs',
  });

  //  this.triggerHj('react_wizard');
   this.url = null
}

/*
 * Queue execute
 */
EventTracking.prototype.executeQueue = function executeQueue() {
  for (let i = 0; i < this.queue.length; i += 1) {
    const c = this.queue[i];
    const args = [];
    if (c.length > 1) {
      for (let x = 0; x < c[1].length; x += 1) args.push(c[1][x]);

      args.push(true);

      const r = this[c[0]].apply(this, args);
      if (r === true) { this.queue.splice(i, 1); }
    }
  }
};

EventTracking.prototype.queueTimeout = function queueTimeout() {
  if (this.queueTimer !== null) clearTimeout(this.queueTimer);

  const that = this;
  this.queueTimer = setTimeout(() => {
    that.executeQueue();
  }, 500);
};

/*
 * Event tracking
 */
EventTracking.prototype.track = function track(eventName, eventProps) {
  // // Mixpanel
  // this.trackMix(eventName, eventProps);

  // // Facebook Pixel
  // this.trackFB(eventName, eventProps);

  // // Google Analytics
  // this.trackGA(eventName, eventProps);

  // SendinBlue
  this.trackSIB(eventName, eventProps);

  // console.log('Tracking '+eventName);
  // console.log(eventProps);
};

/**
 * Here the word checkout only means that we have started a paid funnel
 * Doesn't not mean we are on the chckout step
 */
EventTracking.prototype.trackGTMCheckoutStep = function trackGTMCheckoutStep(checkoutStepNumber, checkoutStepName, contract, checkoutOperation = null, metaId, packNames = []) {
  let price

  this.packName = packNames.length > 0 ? packNames[checkoutOperation.pack] : undefined
  price = checkoutOperation && checkoutOperation.prices ? checkoutOperation.prices[Object.keys(checkoutOperation.prices)[checkoutOperation.pack]] : undefined
  const type = lpApp.type && (lpApp.type === 'demarche' ? 'Démarche' : 'Contrat')
  let productPrice = (checkoutOperation && price) ? price : undefined
  if (!productPrice && checkoutOperation && checkoutOperation.prices && checkoutOperation.prices.first_price) {
    productPrice = checkoutOperation.prices.first_price
  }
  const products = [
    {
      productId: lpApp.contractMetaId || undefined,
      productName: contract ? contract.name : undefined,
      productCategory: type,
      productBrand: 'Legalplace',
      productVariant: checkoutOperation ? this.packName : undefined,
      productPrice: productPrice,
      productQuantity: 1,
      productFormVersion: contract ? `${contract.version}` : undefined
    }
  ]

  if (HARCODED_CHECKOUT_META_IDS.indexOf(metaId) > -1 && lpApp.getState().account_settings.is_crea_assiste_sub) {
    products.push({
        productId: lpApp.contractMetaId || undefined,
        productName: 'Assistance LegalPlace',
        productBrand: 'LegalPlace',
        productCategory: type,
        productVariant: undefined,
        productPrice: '0.00',
        productQuantity: 1,
        productFormVersion: contract ? `${contract.version}` : undefined
    })
  }

  dataLayer.push(gtmCheckoutEvent({
    currencyCode: 'EUR',
    checkoutStepNumber,
    checkoutStepName,
    products
  }))
}

EventTracking.prototype.trackErrorPaymentCheckout = function trackErrorPaymentCheckout(errorMessage) {
  // eslint-disable-next-line no-undef
  dataLayer.push(getContractGAEvent({
    eventCategory: 'Payment error',
    eventAction: 'Clic sur Payer',
    eventLabel: errorMessage,
  }))
}


EventTracking.prototype.trackGTMFunnel = function trackGTMFunnel(pathname, paid = false) {
  //console.log(pathname, lpApp.getState().contract.name, lpApp.getState().contract.section.label)
  if (this.url !== pathname)
  {
  this.url = pathname
  let step = pathname.split('/').length > 1 ? pathname.split('/')[pathname.split('/').length - 1] : undefined
  const totalSections = Object.keys(lpApp.getState().contract.sections).length + 1
  const metaId = lpApp.contractMetaId
  const constStep = step;
  let pageAction;
  let sectionTitle;
  if (step === 'checkout' && !paid) {
    pageAction = HARCODED_CHECKOUT_META_IDS.indexOf(metaId) > -1 ? 'Confirmation avant paiement 2 | 2' : 'Confirmation avant paiement 1 | 1'
    sectionTitle = 'Recapitulatif de votre commande'
  } else if (step === 'paiement') {
    pageAction = 'Confirmation avant paiement 1 | 2'
    sectionTitle = 'Choississez votre pack'
  } else if (step === 'checkout' && paid) {
    pageAction = 'Paiement confirmation'
    sectionTitle = 'Paiement confirmation'
  } else if (parseInt(step, 10) === totalSections) {
    pageAction = `Questionnaire : ${step} | ${totalSections}`
    sectionTitle = "Votre adresse email"
  } else {
    step = (step && step.length < 10) ? step : 1
    pageAction = `Questionnaire : ${step} | ${totalSections}`
    sectionTitle = step && lpApp.getState().contract.sections[step -1] ? lpApp.getState().contract.sections[step -1].label : undefined
  }
  // don't do this event for expert-comptable
  if (constStep !== 'expert-comptable') {
    dataLayer.push(getContractFunnelGAEvent({
      contractName: lpApp.getState().contract.name,
      sectionTitle,
      pageAction
    }))
  }

  }

}

EventTracking.prototype.trackPopUpCheckout = function trackPopUpCheckout() {
  dataLayer.push(getContractFunnelGAEvent({
    contractName: lpApp.getState().contract.name,
    sectionTitle: "Pop-in paiement",
    pageAction: "Pop-in paiement"
  }))
}

EventTracking.prototype.trackClickPayment = function trackClickPayment() {
  dataLayer.push(getContractFunnelGAEvent({
    contractName: lpApp.getState().contract.name,
    sectionTitle: "Clic sur Payer",
    pageAction: "Clic sur Payer"
  }))
}


EventTracking.prototype.trackGTMGAEvent = function trackGTMGAEvent(eventCategory, eventAction, eventLabel) {
  dataLayer.push(getContractGAEvent({
    eventCategory,
    eventAction,
    eventLabel
  }))
}

EventTracking.prototype.trackGTMOrder = function trackGTMOrder(orderId, orderShipping, orderTax, orderPaymentMethod, packPriceWithReduction, acteProduct = true) {
  const checkoutOperation = lpApp.getState().checkout_operations
  const price = checkoutOperation && checkoutOperation.prices ? checkoutOperation.prices[Object.keys(checkoutOperation.prices)[checkoutOperation.pack]] : undefined
  const contract = lpApp.getState().contract
  const type = lpApp.type && (lpApp.type === 'demarche' ? 'Démarche' : 'Contrat')

  let paymentMethod
  switch (orderPaymentMethod) {
      case 'paypal' : paymentMethod = 'Paypal'; break;
      case 'alma' : paymentMethod = 'Carte bancaire en 3 fois'; break;
      default : paymentMethod = 'Carte bancaire'; break;
  }
  const priceActeHT = acteProduct && lpApp.ops.checkout.getHTPrice() && parseFloat(lpApp.ops.checkout.getHTPrice()).toFixed(2)
  const priceActeTVA = acteProduct &&  lpApp.ops.checkout.getHTPrice() && (parseFloat(lpApp.ops.checkout.getTTCPrice()) - parseFloat(lpApp.ops.checkout.getHTPrice())).toFixed(2)
  const products = [
    {
      productId: lpApp.contractMetaId || undefined,
      productName: contract ? contract.name : undefined,
      productCategory: type,
      productBrand: 'Legalplace',
      productVariant: checkoutOperation ? this.packName : undefined,
      productPrice: priceActeHT ||  ((checkoutOperation && price) ? price : (packPriceWithReduction || undefined)),
      productQuantity: 1,
      productFormVersion: contract ? `${contract.version}` : undefined
    }
  ]

  if (HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 && lpApp.getState().account_settings.is_crea_assiste_sub) {
    products.push({
        productId: lpApp.contractMetaId || undefined,
        productName: 'Assistance LegalPlace',
        productBrand: 'LegalPlace',
        productCategory: type,
        productVariant: undefined,
        productPrice: '0.00',
        productQuantity: 1,
        productFormVersion: contract ? `${contract.version}` : undefined
    })
  }
  dataLayer.push(gtmAchatEvent({
    products,
    currencyCode: 'EUR',
    orderId,
    orderRevenue: priceActeHT || packPriceWithReduction || 0,
    orderShipping,
    orderTax: priceActeTVA || orderTax ,
    orderPack: this.packName,
    orderNewCustomer: lpApp.newCustomer ? 'Oui' : 'Non',
    orderTunnelType: HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1
      ? 'Créations'
      : (price > 0 ? 'Actes payants' : 'Actes gratuits'),
    orderPaymentMethod: paymentMethod,
    orderCoupon: checkoutOperation && checkoutOperation.promo_code ? `${checkoutOperation.promo_code} - ${checkoutOperation.promo_percentage * 100}%` : undefined,
    orderFormVersion: contract ? `${contract.version}` : undefined,
    orderOption: HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 && lpApp.getState().account_settings.is_crea_assiste_sub ? 'Oui' : 'Non'
  }))
}

/*
 * Event tracking in Mixpanel
 */
EventTracking.prototype.trackMix = function trackMix(eventName, eventProps, doNotPushToQueue) {
  if (typeof (window.mixpanel) !== 'undefined') {
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();
    window.mixpanel.track(eventName, eventProps);
    return true;
  }
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['trackMix', arguments]);

  this.queueTimeout();
  return false;
};

/*
 * Event tracking in Mixpanel
 */
EventTracking.prototype.trackAbTasty = function trackAbTasty(eventName, eventProps, doNotPushToQueue) {
  if (typeof (window.abtasty) !== 'undefined') {
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();

    window.abtasty.send('transaction', {
      tid: eventProps.uniqid,
      ta: eventName,
      tr: eventProps.revenue,
      tt: eventProps.itemPrice/6,
      tc: 'EUR',
      tcc: eventProps.couponCode,
      pm: eventProps.paymentMethod,
      icn: 1
    });

    window.abtasty.send('item', {
      tid: eventProps.uniqid,
      in: eventProps.itemName,
      ip: eventProps.itemPrice,
      iq: 1
    })

    return true;
  }
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['trackAbTasty', arguments]);

  this.queueTimeout();
  return false;
};

/*
 * Event tracking in SendinBlue
 */
EventTracking.prototype.trackSIB = function trackSIB(eventName, eventProps, doNotPushToQueue) {
  if (typeof (window.sendinblue) !== 'undefined') {
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();
    window.sendinblue.track(eventName, eventProps);
    return true;
  }
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['trackSIB', arguments]);

  this.queueTimeout();
  return false;
};

/*
 * Event tracking in Facebook Pixel
 */
EventTracking.prototype.trackFB = function trackFB(
  eventName,
  eventProps,
  doNotPushToQueue,
  ...args
) {
  if (typeof (window.fbq) !== 'undefined') {
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();
    window.fbq('trackCustom', eventName, eventProps);
    return true;
  }
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['trackFB', ...args]);

  this.queueTimeout();
  return false;
};

/*
 * Event tracking in Google Analytucs
 */
EventTracking.prototype.trackGA = function trackGA(
  eventName,
  eventProps,
  doNotPushToQueue,
  ...args
) {
  if (typeof (window.ga) !== 'undefined') {
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();
    window.ga('send', 'event', 'lpTracking', 'track', eventName, 1, eventProps);
    return true;
  }
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['trackGA', ...args]);

  this.queueTimeout();
  return false;
};

/*
 * Props register
 */
EventTracking.prototype.register = function register(props) {
  // Mixpanel
  this.registerMix(props);

  // Facebook Pixel
  this.registerFB(props);
};

/*
 * Props register Mixpanel
 */
EventTracking.prototype.registerMix = function registerMix(props, doNotPushToQueue, ...args) {
  if (typeof (window.mixpanel) !== 'undefined') {
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();
    window.mixpanel.register(props);
    return true;
  }
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['registerMix', ...args]);

  this.queueTimeout();
  return false;
};

/*
 * Props register Facebook Pixel
 */
EventTracking.prototype.registerFB = function registerFB(props, doNotPushToQueue, ...args) {
  if (typeof (window.fbq) !== 'undefined') {
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();
    window.fbq('trackCustom', 'GeneralProps', props);
    return true;
  }
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['registerFB', ...args]);

  this.queueTimeout();
  return false;
};

/*
 * Props trigger
 */
EventTracking.prototype.trigger = function trigger(name) {
  // Hotjar
  this.triggerHj(name);
};

/*
 * Hotjar trigger helper
 */
EventTracking.prototype.triggerHj = function triggerHj(name, doNotPushToQueue, ...args) {
  // Making sure HJ tracking lib is loaded
  if (typeof (window.hj) !== 'undefined') {
    // If queue isn't empty & function hasn't been called by executeQueue
    if (this.queue.length > 0 && !doNotPushToQueue) this.executeQueue();

    // Trigger
    window.hj('trigger', name);

    return true;
  }

  // Adding to queue
  if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['triggerHj', ...args]);

  this.queueTimeout();
  return false;
};

/**
 * Adwords conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */
EventTracking.prototype.adwordsConversion = function adwordsConversion(
  props,
  doNotPushToQueue,
  ...args
) {
  // Making sure Google Adwords conversion script is loaded
  if (typeof (window.google_trackConversion) === 'undefined') {
    if (typeof (doNotPushToQueue) === 'undefined') this.queue.push(['adwordsConversion', ...args]);
    return false;
  }

  /** Do NOT track conversions for free products */
  if (props.google_conversion_value === 0) return

  // Default tracking props
  const defaultProps = {
    google_conversion_id: 958034329,
    google_conversion_language: 'en',
    google_conversion_format: '3',
    google_conversion_color: 'ffffff',
    google_conversion_label: 'ZcUkCN3ntIoBEJnj6cgD',
    google_conversion_value: 0,
    google_remarketing_only: false,
  };

  // Overriding default props by props
  if (typeof (props) === 'object') {
    const propsKeys = Object.keys(props);
    for (let i = 0; i < propsKeys.length; i += 1) {
      const currentKey = propsKeys[i];

      // Making sure key exists in default props
      if (Object.prototype.hasOwnProperty.call(defaultProps, currentKey)) {
        defaultProps[currentKey] = props[currentKey];
      }
    }
  }

  // Tracking conversion
  window.google_trackConversion(defaultProps);

  return true;
};

/**
 * Bing conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */
EventTracking.prototype.bingConversion = function bingConversion(props, doNotPushToQueue){
  // Making sure Bing Ad conversion script is loaded
  if(typeof(window.uetq) == 'undefined'){
    if(typeof(doNotPushToQueue) == 'undefined')
      this.queue.push(['bingConversion', arguments]);
    return false;
  }

  /** Do NOT track conversions for free products */
  if (props.gv === 0) return

  // Default tracking props
  var default_props = {
    ea: 'Purchase',
    gv: 0,
    gc: 'EUR'
  };

  // Overriding default props by props
  if(typeof(props) == 'object'){
    var props_keys = Object.keys(props);
    for(var i = 0; i < props_keys.length; i++){
      var current_key = props_keys[i];

      // Making sure key exists in default props
      if(!default_props.hasOwnProperty(current_key))
        continue;

      default_props[current_key] = props[current_key];
    }
  }

  // Tracking convertion
  window.uetq = window.uetq || [];
  window.uetq.push(default_props);

  return true;
};

/**
 * Facebook conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */
EventTracking.prototype.facebookConversion = function facebookConversion(props, doNotPushToQueue){
  // Making sure Facebook Ad conversion script is loaded
  if(typeof(window.fbq) == 'undefined'){
    if(typeof(doNotPushToQueue) == 'undefined')
      this.queue.push(['facebookConversion', arguments]);
    return false;
  }

  /** Do NOT track conversions for free products */
  if (props.value === 0) return

  // Default tracking props
  var default_props =  {
    content_type: 'product',
    content_ids: [0],
    value: 0,
    currency: 'EUR'
  };

  // Overriding default props by props
  if(typeof(props) == 'object'){
    var props_keys = Object.keys(props);
    for(var i = 0; i < props_keys.length; i++){
      var current_key = props_keys[i];

      // Making sure key exists in default props
      if(!default_props.hasOwnProperty(current_key))
        continue;

      default_props[current_key] = props[current_key];
    }
  }

  // Tracking convertion
  window.fbq('track', 'Purchase', default_props);

  return true;
};

/**
 * Google Analytics conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */
EventTracking.prototype.gAnalyticsConversion = function gAnalyticsConversion(props, doNotPushToQueue){
  // Making sure Facebook Ad conversion script is loaded
  if(typeof(window.ga) == 'undefined'){
    if(typeof(doNotPushToQueue) == 'undefined')
      this.queue.push(['gAnalyticsConversion', arguments]);
    return false;
  }

  /** Do NOT track conversions for free products */
  if (props.price === 0) return

  // Default tracking props
  var default_props =   {
    id: new Date().getTime(),
    affiliation: 'LegalPlace',
    revenue: 0,
    price: 0,
    shipping: 0,
    tax: 0,
    name: '',
    currency: 'EUR',
    quantity: '1'
  };

  // Overriding default props by props
  if(typeof(props) == 'object'){
    var props_keys = Object.keys(props);
    for(var i = 0; i < props_keys.length; i++){
      var current_key = props_keys[i];

      // Making sure key exists in default props
      if(!default_props.hasOwnProperty(current_key))
        continue;

      default_props[current_key] = props[current_key];
    }
  }

  // Tracking convertion
  window.ga('send', 'event', 'Payment', 'Download', default_props.price);

  window.ga('require', 'ecommerce');
  window.ga('ecommerce:addTransaction', default_props);
  window.ga('ecommerce:addItem', default_props);
  window.ga('ecommerce:send');

  return true;
};



EventTracking.prototype.trackDatalayerMixpanel = function trackDatalayerMixpanel(eventCategory, eventLabel, eventAction = 'Clic') {
  dataLayer.push({
    event: "eventMXP",
    eventCategory,
    eventLabel,
    eventAction
  })
}

EventTracking.prototype.trackDatalayerSendinBlue = function trackDatalayerSendinBlue(SBInfos) {
  dataLayer.push({
    event: "avocatyExtraction",
    SBInfos
  })
}

const lpevents = new EventTracking();
window.lpevents = new EventTracking();

export default lpevents;



// WEBPACK FOOTER //
// ./src/tracking/lpevents.js